import { ClientOverrideContext } from './clientOverrideContext';
import { ClientId } from './types';

function ClientContainer({ clientOverride = null, children }: React.PropsWithChildren<{ clientOverride?: ClientId | null }>) {
  return (
    <ClientOverrideContext.Provider value={clientOverride}>
      {children}
    </ClientOverrideContext.Provider>
  );
}

export default ClientContainer;
